export enum DateType {
  Travel = 'T',
  Booking = 'B'
}
